import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

export default function QuizBanner() {
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate('/quiz')}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') navigate('/quiz'); }}
      style={{
        background: 'linear-gradient(135deg, #a78bfa 0%, #7c3aed 100%)',
        borderRadius: '20px',
        padding: '24px 20px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 12px 24px rgba(124, 58, 237, 0.25)',
        marginBottom: '24px',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div style={{ position: 'absolute', right: '-10%', top: '-20%', opacity: 0.1, transform: 'scale(2)' }}>
        <Sparkles size={100} />
      </div>
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
          <Sparkles size={18} color="#fcd34d" />
          <span style={{ fontSize: '13px', fontWeight: '800', color: '#fcd34d', letterSpacing: '1px' }}>MINI GAME</span>
        </div>
        <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '800', lineHeight: '1.3' }}>不知道想做什麼？<br />測測你的潛在社交人格！</h3>
      </div>
      
      <div style={{ position: 'relative', zIndex: 1, width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, backdropFilter: 'blur(4px)' }}>
        <ArrowRight size={20} strokeWidth={2.5} />
      </div>
    </div>
  );
}
